import { render, staticRenderFns } from "./CollectionPerformanceReportView.vue?vue&type=template&id=73391b02"
import script from "./CollectionPerformanceReportView.vue?vue&type=script&lang=js"
export * from "./CollectionPerformanceReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports